const breadcrumbs = {
  namespaced: true,
  state: {
    header: '',
    trail: [],
  },
  mutations: {
    updateBreadcrumbs: (oldState, payload) => {
      const newState = oldState;
      newState.header = payload.breadcrumbs.header;
      newState.trail = payload.breadcrumbs.trail;
      return newState;
    },
  },
  actions: {
    updateBreadcrumbs(context, payload) {
      context.commit('updateBreadcrumbs', payload);
    },
  },
};

export default breadcrumbs;
